import { TFunction } from 'i18next'
import { FieldType, IFormConfig } from 'types'
import { MainContact, mainContactSchema } from './main-contact-schema'
import { PhoneNumberField } from 'components/PhoneNumberField'
import { FullNameFields } from 'components/FullNameFields'
import { CountryAlpha2 } from 'generated/graphql'

export const getMainContactModalConfig = (
  t: TFunction
): IFormConfig<MainContact> => ({
  schema: mainContactSchema,
  fields: [
    {
      name: 'individual.firstName',
      type: FieldType.CUSTOM,
      label: t('individuals.mainContact.fields.firstName.label'),
      tooltip: t('individuals.mainContact.fields.firstName.tooltip'),
      CustomComponent: FullNameFields,
      customComponentProps: {
        fields: [
          {
            name: 'individual.firstName',
            label: t('individuals.mainContact.fields.firstName.label'),
            placeholder: t(
              'individuals.mainContact.fields.firstName.placeholder'
            )
          },
          {
            name: 'individual.lastName',
            label: t('individuals.mainContact.fields.lastName.label'),
            placeholder: t(
              'individuals.mainContact.fields.lastName.placeholder'
            )
          }
        ]
      }
    },
    {
      name: 'relation.title',
      label: t('individuals.mainContact.fields.title.label'),
      placeholder: t('individuals.mainContact.fields.title.placeholder'),
      tooltip: t('individuals.mainContact.fields.title.tooltip')
    },
    {
      name: 'individual.email',
      label: t('individuals.mainContact.fields.email.label'),
      placeholder: t('individuals.mainContact.fields.email.placeholder'),
      disabled: true
    },
    {
      name: 'individual.phoneNumber',
      type: FieldType.CUSTOM,
      label: t('individuals.mainContact.fields.phoneNumber.label'),
      tooltip: t('individuals.mainContact.fields.phoneNumber.tooltip'),
      CustomComponent: PhoneNumberField
    }
  ]
})
